"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOTP = exports.randomToken = void 0;
const utils_1 = require("./utils");
Object.defineProperty(exports, "randomToken", { enumerable: true, get: function () { return utils_1.randomToken; } });
const CONSTANTS = {
    OTP_LENGTH: 6,
};
class HOTP {
    constructor(options) {
        this.options = options;
    }
    static generateSecret(length) {
        return utils_1.randomToken(length);
    }
    async generate(secret, timeCounter, options) {
        var _a, _b, _c, _d, _e, _f;
        const otpLength = (_a = options === null || options === void 0 ? void 0 : options.length) !== null && _a !== void 0 ? _a : CONSTANTS.OTP_LENGTH;
        const _base32Decode = (_d = (_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.base32) === null || _c === void 0 ? void 0 : _c.decode) !== null && _d !== void 0 ? _d : utils_1.base32Decode;
        const _hmacSha1 = (_f = (_e = this.options) === null || _e === void 0 ? void 0 : _e.hmac) !== null && _f !== void 0 ? _f : utils_1.hmacSha1;
        const timeCounterBytes = utils_1.timeCounter2ByteText(timeCounter);
        const decodedSecret = await _base32Decode(secret);
        const secretHashHex = await _hmacSha1(decodedSecret, timeCounterBytes);
        return utils_1.truncat(secretHashHex, otpLength);
    }
    async verify(token, secret, timeCounter) {
        return token === (await this.generate(secret, timeCounter));
    }
    async getURI(secret, account, issuer) {
        return `otpauth://hotp/${account}?issuer=${issuer}&secret=${secret}`;
    }
}
exports.HOTP = HOTP;
exports.default = HOTP;
